$(document).ready(function(){

   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }

   $(".addtocart").on('click', function(e) {
      var elem = $(this);
      $(elem).prop("disabled", true);

      e.preventDefault();
      addItem('add-item-form');
   });

   Shopify.onSuccess = function() {

      var elem = $('.addtocart');

      elem.removeAttr("disabled");

      var quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;

      $("html, body").animate({ scrollTop: 0 }, 250, 'swing');

      function animate() {

        $("#cart-animation").hide();

        var addtocartWidth = elem.outerWidth() / 2
        var addtocartHeight = elem.outerHeight() / 2

        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = $(elem).offset().top + addtocartHeight ;

        var buttonAreaWidth = $("#cart-target").outerWidth();
        var buttonAreaHeight = $("#cart-target").outerHeight();

        var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2  - $("#cart-animation").outerWidth() / 2) - 4 - 18;
        var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2  - $("#cart-animation").outerHeight() / 2) - 4 - 8;

        var path = {
          start: {
            x: addtocartLeft,
            y: addtocartTop,
            angle: 190.012,
            length: 0.2
          },
          end: {
            x: buttonAreaLeft,
            y: buttonAreaTop,
            angle: 90.012,
            length: 0.50
          }
        };

        $('#cart-animation').text(quantity).animate(
        {
          path : new $.path.bezier(path)
        },
        1200,
        function() {
          $("#cart-animation").fadeOut(500, function() {
            $(elem).prop("disabled", false)
            var cartCount =  parseInt($('#cart-count').text()) + quantity;
            $('#cart-count, #cart-count-mobile, #cart-count-tablet').text(cartCount)
            $('#cart-target, #cart-target-mobile, #cart-target-tablet').addClass('has-items');

            Shopify.getCart(function(cart) { console.log(cart);
              updateMiniCart(cart);
            });
          })
        }
        );
      }

      animate();
    };

    var updateMiniCart = function(cart) {
      var i, item, itemProperties, itemText, j, len, miniCartItemsWrap, productPrice, propertiesArray, propertyKeysArray, ref, variant;
      miniCartItemsWrap = $(".mini-cart-items-wrap");
      miniCartItemsWrap.empty();
      if (cart.item_count !== 1) {
        itemText = Theme.cartItemsOther;
      } else {
        itemText = Theme.cartItemsOne;
        $(".mini-cart .options").show();
        miniCartItemsWrap.find(".no-items").hide();
      }
      $(".mini-cart-wrap label").html("<span class='item-count'>" + cart.item_count + "</span> " + itemText);
      ref = cart.items;
      for (j = 0, len = ref.length; j < len; j++) {
        item = ref[j];
        productPrice = Shopify.formatMoney(item.line_price, Theme.moneyFormat);
        variant = item.variant_title ? "<p class='variant'>" + item.variant_title + "</p>" : "";
        itemProperties = "";
        if (item.properties) {
          propertyKeysArray = Object.keys(item.properties);
          propertiesArray = _.values(item.properties);
          i = 0;
          while (i < propertyKeysArray.length) {
            if (propertiesArray[i].length) {
              itemProperties = itemProperties + ("<p class=\"property\">\n    <span class=\"property-label\">" + propertyKeysArray[i] + ":</span>\n    <span class=\"property-value\">" + propertiesArray[i] + "</span>\n</p>");
            }
            i++;
          }
        }
        miniCartItemsWrap.append("<div id=\"item-" + item.variant_id + "\" class=\"item clearfix\">\n    <div class=\"image-wrap\">\n        <img alt=\"" + item.title + "\" src=\"" + item.image + "\">\n        <a class=\"overlay\" href=\"" + item.url + "\"></a>\n    </div>\n    <div class=\"details\">\n        <p class=\"brand\">" + item.vendor + "</p>\n        <p class=\"title\"><a href=\"" + item.url + "\">" + item.product_title + "</a><span class=\"quantity\">× <span class=\"count\">" + item.quantity + "</span></span></p>\n        <p class=\"price\"><span class=\"money\">" + productPrice + "</span></p>\n        " + variant + "\n        " + itemProperties + "\n    </div>\n</div>");
      }
    };

    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };

});

jQuery(window).load(function() {
  $(".testimonial-slider").flexslider({
    slideshow: true,
    animationLoop: true,
    controlNav: true,
    directionNav: true,
    animation: "fade",
    touch: true,
    prevText: "",
    nextText: "",
  })
})

jQuery(window).load(function(){
  $(".js-brands-slider").flexslider({
    slideshow: true,
    animationLoop: true,
    controlNav: false,
    animation: "slide",
    itemWidth: 220,
    minItems: 1,
    maxItems: 5,
    touch: true,
  });
  if ( $('.slides li').size() > 1 ) {
    var animateSlider = function(slider) {
      $(slider).find('.flex-active-slide .animate--add--fadeInDown').animateCss('fadeInDown');
      $(slider).find('.flex-active-slide .animate--add--fadeInUp').animateCss('fadeInUp');
    };
    $('#homepage-slider').flexslider({
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 5000,
      animation: "fade",
      controlNav: true,
      prevText: "",
      nextText: "",
      start: animateSlider,
      before: function(slider) {
        $(slider).find('.animate--add--fadeInDown, .animate--add--fadeInUp').addClass('visualHidden');
      },
      after: animateSlider,
    });
  }

  $("select.loc_on_change").change(function(){
  	if($(this).attr("value") == "#") return false;
  	window.location = $(this).attr("value");
  });
});

/*============================*/
/* Update main product image. */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  if ($('#product .thumbs a[href="'+newImageSrc+'"]').hasClass('hasVideo')) {
    $('#product .featured, .iframe-wrapper').hide();
    $('#product .iframe-wrap-main').show();

    $('.iframe-wrapper[data-href="'+newImageSrc+'"]').show();
  } else {
    $('#product .featured').show();
    $('#product .iframe-wrap-main, .iframe-wrapper').hide();

    // newImageSrc is the path of the new image in the same size as originalImage is sized.
    // newImage is Shopify's object representation of the new image, with various attributes, such as scr, id, position.
    // mainImageDomEl is the passed domElement, which has not yet been manipulated. Let's manipulate it now.
    jQuery(mainImageDomEl).attr('src', newImageSrc);
    
    if ($(window).width() > 782) {jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom( { url: newImageSrc.replace('_master', '') } );}
    
  }

  if($('#product .thumbs a[href="'+newImageSrc+'"]')) {
    $('#product .thumbs .image').removeClass('isActive');
    $("#product .thumbs a[href='"+newImageSrc+"']").parent().addClass('isActive');
  }
};


jQuery(document).ready(function($){

  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });

  /* Update main product image when a thumbnail is clicked. */
  /*==========================*/
  $('#product .thumbs a').on('click', function(e) {
    e.preventDefault();
    $('#product .thumbs .image').removeClass('isActive');
    $(this).parent().addClass('isActive');

    if ($(this).hasClass('hasVideo')) {
      $('#product .featured, .iframe-wrapper').hide();
      $('#product .iframe-wrap-main').show();

      $('.iframe-wrapper[data-href="'+$(this).attr('href')+'"]').show();
    } else {
      $('#product .featured').show();
      $('#product .iframe-wrap-main, .iframe-wrapper').hide();

      switchImage($(this).attr('href'), null, $('.featured img')[0]);
    }
  });


  
  /* Initialize zoom on main product image */
  var mainProductImage = $('.featured img');
  if (mainProductImage.size()) {
    if ($(window).width() > 782) {
    var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
    $('.featured img')
      .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
      .css('display', 'block')
      .parent()
      .zoom( { url: zoomedSrc } );
	}
  }
  

  var iframes = jQuery('body').find('iframe');

  if ( iframes.length && !iframes.parent().hasClass('pogon-fluid-iframe') ) {
    for ( var i = 0; i < iframes.length; i++ ) {
      var iframe = iframes[i],
        players = /www.youtube.com|player.vimeo.com|google.com\/maps/;

      if ( iframe.src.search( players ) > 0 ) {
        var videoRatio        = ( iframe.height / iframe.width ) * 100;
        iframe.style.position = 'absolute';
        iframe.style.top      = '0';
        iframe.style.left     = '0';
        iframe.width          = '100%';
        iframe.height         = '100%';

        var wrap              = document.createElement( 'div' );
        wrap.className        = 'pogon-fluid-iframe';
        wrap.style.width      = '100%';
        wrap.style.position   = 'relative';
        wrap.style.paddingTop = videoRatio + '%';
        var iframeParent      = iframe.parentNode;
        iframeParent.insertBefore( wrap, iframe );
        wrap.appendChild( iframe );
      }
    }
  }

  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });

  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  })

  $(".main li.dropdown").hover(function(){
    $(this).children('.dropdown').show();
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 1.0
    }, 200);
  }, function(){
    $(this).children('.dropdown').stop();
    $(this).children('.dropdown').animate({
      opacity: 0.0
    }, 400, function(){
      $(this).hide();
    });
  });


  /**
   * An array of instagram posts
   */
  var instagramPosts;

  /**
   * Get the instagram posts from the instagram api
   */
  $.ajax({
    type: "GET",
    url: "https://api.instagram.com/v1/users/self/media/recent/?",
    dataType: "jsonp",
    cache: false,
    data: {
      access_token: Theme.insta_a_t,
      count: 20
    }
  })
  .done(function(res) {
    instagramPosts = res.data;

    if (instagramPosts && instagramPosts.length) {
      createInstaFeed($('.instagram-feed-user'));

      $(window).load(function() {
        var instaFeed = $('#instagram-feed-carousel').flexslider({
          animation: "slide",
          itemWidth: 210,
          itemMargin: 20,
          minItems: 2,
          maxItems: 5,
          move: 1,
          controlNav: false,
          start: function(slider) {
            instaFeed.resize();
          }
        });
      });
    }
  })
  .fail(function(res) {
  });

  function createInstaFeed(parent) {
    $.each(instagramPosts, function(i,v) {
      var item;

      item = '<li><a href="'+v.link+'" target="_blank"><img src="'+v.images.standard_resolution.url+'" alt="Instagram Image" data-filter="'+v.filter+'" /><div class="details"><div class="table"><div class="tcell"><i class="icon-instagram"></i><p>'+timeConverter(v.caption.created_time)+'</p></div></div></div></a></li>';

      parent.append(item);
    });
  }

  function timeConverter(UNIX_timestamp){
    var a = new Date(UNIX_timestamp * 1000);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var year = a.getFullYear();
    var month = months[a.getMonth()];
    var date = a.getDate();
    var time = date + ' ' + month + '. ' + year;
    return time;
  }

  /**
   * An array of instagram posts with #livenhappily
   */
  var instagramTagPosts;

  /**
   * Get the instagram posts from the instagram api
   */
  $.ajax({
    type: "GET",
    url: "https://api.instagram.com/v1/tags/livenhappily/media/recent?",
    dataType: "jsonp",
    cache: false,
    data: {
      access_token: Theme.insta_a_t,
      count: 10
    }
  })
  .done(function(res) {
    instagramTagPosts = res.data;

    if (instagramTagPosts && instagramTagPosts.length) {
      createTagInstaFeed($('.instagram-feed-tag'));
    }
  })
  .fail(function(res) {
  });

  function createTagInstaFeed(parent) {
    $.each(instagramTagPosts, function(i,v) {
      var item;

      item = '<li><a href="'+v.link+'" target="_blank"><img src="'+v.images.standard_resolution.url+'" alt="Instagram Image" data-filter="'+v.filter+'" /><div class="details"><div class="table"><div class="tcell"><i class="icon-instagram"></i><p>'+v.caption.text+'</p></div></div></div></a></li>';

      parent.append(item);
    });
  }

  /**
   *  Related Products Carousel
   */
  $('.related-products-list').slick({
    autoplay: true,
    infinite: true,
    centerMode: true,
    centerPadding: '0px',
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '0',
          slidesToShow: 1
        }
      }
    ]
  });

  $('body').on('click', '.related-products-list .product', function(e) {
      var self = $(this);

      if (self.hasClass('slick-center')) {
          window.location = self.attr('href');
      } else {
          e.preventDefault();

          var slide_wrap = $('.related-products-list'),
              slide_index = self.data('slick-index');

          slide_wrap.slick('slickGoTo', slide_index);
      }
  });

  /**
   * Mini Cart
   */
  $('.mini-cart-wrap').on('click', '.cart', function(e) {
    e.preventDefault();
    e.stopPropagation();

    $('.mini-cart').toggleClass('isOpen').stop().fadeToggle();
  });

  $('.mini-cart').on('click', function(e) {
    e.stopPropagation();
  });

  $('body').on('click', function(e) {
    if ($('.mini-cart').hasClass('isOpen')) {
      $('.mini-cart').removeClass('isOpen').stop().fadeOut();
    }
  });

  /**
   *  Main Nav Hover functionality
   */
  jQuery('body.home').on({
    mouseenter: function() {
      jQuery('#header, #homepage-slider').addClass('isHover');
    },
    mouseleave: function() {
      jQuery('#header, #homepage-slider').removeClass('isHover');
    }
  });
  $(document).on('scroll', function() {
    $('body.home .yotpo-testimonials-btn').fadeIn();
  });
  
  var scrolled = false;
  $(document).on('scroll', function() {
    if (!scrolled) {
      $('#header').addClass('isHover');
      scrolled = true;
    }
  });
  
  
  /**
   *  ScrollReveal
   */
  window.sr = ScrollReveal();

  sr.reveal('.reveal-left', {
    duration: 2000,
    origin: 'left',
    scale: 1,
    mobile: false,
    viewFactor: 1,
    distance: '500px'
  });

  sr.reveal('.reveal-right', {
    duration: 2000,
    origin: 'right',
    scale: 1,
    mobile: false,
    viewFactor: 1,
    distance: '500px'
  });

  sr.reveal('.reveal-bottom', {
    duration: 2000,
    origin: 'bottom',
    scale: 1,
    mobile: false,
    viewFactor: 1,
    distance: '500px'
  });

  sr.reveal('.js-fade-in-1', { duration: 2000, mobile: false });
  sr.reveal('.js-fade-in-2', { duration: 2000, mobile: false, delay: 500 });
  sr.reveal('.js-fade-in-3', { duration: 2000, mobile: false, delay: 1000 });

  /**
   * Mobile Menu
   */
  $('.hamburger').on('click', function(e) {
    $(this).toggleClass('isOpen');
    $('#hamburger').toggleClass('open');
    $('.mobile-menu').stop().slideToggle();
  });

  $('.main-mobile').on('click', 'li.dropdown', function(e) {
    e.preventDefault();
    $(this).find('ul.dropdown').stop().slideToggle();
  });

  $('.main-mobile').on('click', 'ul.dropdown', function(e) {
    e.stopPropagation();
  });

  /**
   *  Collection Ajax Load More
   */
  $('body').on('click', '.ajax-view-more', function(e) {
    e.preventDefault();
    var url = $(this).data('href');

    $.ajax({
      url: url,
      type: "GET",
      beforeSend: function(){
        $('.ajax-view-more').attr('disabled', true).text('Loading');
      },
      complete: function(){
        //$('.ajax-view-more').attr('disable', false).text(loading);
      },
      success: function(data){
        $('.js-filtered-products').append($(data).find('.js-filtered-products').html());
        $('.ajax-pagination').html($(data).find('.ajax-pagination').html());
      },
      error: function(){
      }
      });
  });

  /**
   *  Page Stockists Acordion
   */
  jQuery('.stockist-col h3').on('click', function() {
    jQuery(this).toggleClass('isOpen');
    jQuery(this).next('p').stop().slideToggle();
  });

  /**
   *  Cart
   */
  var updateQuantity = function(e) {
    var id, input, quantity, url;

    input = $(e.currentTarget);
    quantity = input.val();
    id = input.data('id');
    url = "/cart/change/" + id + "?quantity=" + quantity;
    return window.location = url;
  };

  var saveNote = function() {
    var newNote;
    newNote = $('.instructions textarea').val();
    return Shopify.updateCartNote(newNote, function(cart) {});
  };

  var calculateShipping = function(e) {
    var shippingAddress;
    if (e && e.type === 'keydown') {
      if (e.keyCode === 13) {
        e.preventDefault();
        $('.wrapper-response').empty();
      } else {
        return;
      }
    }
    shippingAddress = {};
    shippingAddress.zip = $('.address-zip').val() || '';
    shippingAddress.country = $('.address-country').val() || '';
    shippingAddress.province = $('.address-province').val() || '';
    return Shopify.getCartShippingRatesForDestination(shippingAddress, function() {
      var address, firstRate, j, len, multipleShippingRates, oneShippingRate, price, rate, rateValues, ratesFeedback, results;
      address = shippingAddress.zip + ", " + shippingAddress.province + ", " + shippingAddress.country;
      if (!shippingAddress.province.length) {
        address = shippingAddress.zip + ", " + shippingAddress.country;
      }
      if (!shippingAddress.zip.length) {
        address = shippingAddress.province + ", " + shippingAddress.country;
      }
      if (!(shippingAddress.province.length && shippingAddress.zip.length)) {
        address = shippingAddress.country;
      }
      $('.wrapper-response').empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates unstyled'/>");
      ratesFeedback = $('.shipping-calculator-response');
      if (rates.length > 1) {
        firstRate = Shopify.Cart.ShippingCalculator.formatRate(rates[0].price);
        multipleShippingRates = Theme.shippingCalcMultiRates.replace('{# address #}', address).replace('{# number_of_rates #}', rates.length).replace('{# rate #}', "<span class='money'>" + firstRate + "</span>");
        ratesFeedback.html(multipleShippingRates);
      } else if (rates.length === 1) {
        oneShippingRate = Theme.shippingCalcOneRate.replace('{# address #}', address);
        ratesFeedback.html(oneShippingRate);
      } else {
        ratesFeedback.html(Theme.shippingCalcNoRates);
      }
      results = [];
      for (j = 0, len = rates.length; j < len; j++) {
        rate = rates[j];
        price = Shopify.Cart.ShippingCalculator.formatRate(rate.price);
        rateValues = Theme.shippingCalcRateValues.replace('{# rate_title #}', rate.name).replace('{# rate #}', "<span class='money'>" + price + "</span>");
        results.push($('.shipping-rates').append("<li>" + rateValues + "</li>"));
      }
      return results;
    });
  };

  var handleErrors = function(errors) {
    var errorMessage;
    errorMessage = $.parseJSON(errors.responseText);
    errorMessagePrint = Theme.shippingCalcErrorMessage.replace('{# error_message #}', errorMessage.zip);
    return $('.wrapper-response').html("<p class='message'>" + errorMessagePrint + "</p>");
  };

  Shopify.onError = (function(_this) {
    return function(XMLHttpRequest) {
      return handleErrors(XMLHttpRequest);
    };
  })(this);


  $('.quantity .field').on('change', updateQuantity);
  $('.instructions textarea').on('change', saveNote);
  $('.get-rates').on('click', calculateShipping);
  $('#address_zip').on('keydown', calculateShipping);

  // Cart additional content
  $('.cart-additional-title').on('click', function(e) {
    e.preventDefault();
    $(this).toggleClass('isOpen');
    $(this).next('.cart-additional-content').stop().slideToggle();
  });

  /**
   *  Header Main Search
   */
  $('.header-wrap').on('click', '.search-btn', function(e) {
    e.preventDefault();

    if ($('.header-wrap .search_box').val()) {
      $('.header-wrap .search').submit();
    } else {
      if ($(this).hasClass('isOpen')) {
        $(this).removeClass('isOpen');

        $('.search_box').stop().animate({
          width: 0,
          opacity: 0
        });
      } else {
        $(this).addClass('isOpen');

        $('.search_box').focus().stop().animate({
          width: 240,
          opacity: 1
        });
      }
    }
  });

}); // end document ready

$.fn.extend({
  animateCss: function (animationName) {
      var animationEnd = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';
      this.removeClass('visualHidden').addClass('animated ' + animationName).one(animationEnd, function() {
          $(this).removeClass('animated ' + animationName);
      });
  }
});

/* jQuery css bezier animation support -- Jonah Fox */

;(function($){

  $.path = {};

  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };

  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );

    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];

    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );

    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );

    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );

    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };

    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }

    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }

    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }

    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};

      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };

  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };

})(jQuery);
